$(function () {
  if (window.bt && window.bt.customer && window.bt.customer.isVIP) {
    window.sessionStorage.setItem('isMember', true);
  } else {
    window.sessionStorage.removeItem('isMember');
  }
});